<template>
<div>
     <!-- Administracion -->
        <v-menu text nav v-if="Admin || Legal" bottom offset-y origin="center center" transition="scale-transition">
            <template v-slot:activator="{ attrs, on }">
                <v-btn text v-on="on">
                    <v-icon small>mdi-account-group</v-icon>
                    <span class="caption">Usuarios</span>
                </v-btn>
            </template>
            <v-list :tile="false" nav>
                <app-bar-item to="/catalogos/grupos" @click.shift="openNew('/catalogos/grupos');">

                    <v-icon>mdi-circle-small</v-icon>Grupos

                </app-bar-item>
                <app-bar-item to="/catalogos/usuariosAdmin" @click.shift="openNew('/catalogos/usuariosAdmin');">

                    <v-icon>mdi-circle-small</v-icon>Usuarios de MxTransmite

                </app-bar-item>
                <app-bar-item to="/catalogos/usuariosAdminGrupo" @click.shift="openNew('/catalogos/usuariosAdminGrupo');">

                    <v-icon>mdi-circle-small</v-icon>Usuarios de Grupo

                </app-bar-item>
                <app-bar-item to="/catalogos/clientes" @click.shift="openNew('/catalogos/clientes');">

                    <v-icon>mdi-circle-small</v-icon>Clientes

                </app-bar-item>

                <app-bar-item to="/catalogos/usuarios_clientes" @click.shift="openNew('/catalogos/usuarios_clientes');">

                    <v-icon>mdi-circle-small</v-icon>Usuarios de los Clientes

                </app-bar-item>
                <app-bar-item v-if="Admin" to="/catalogos/perfiles" @click.shift="openNew('/catalogos/perfiles');">

                    <v-icon>mdi-circle-small</v-icon>Administrar Perfiles

                </app-bar-item>

                <app-bar-item v-if="Admin" to="/catalogos/logsistema" @click.shift="openNew('/catalogos/logsistema');">

                    <v-icon>mdi-circle-small</v-icon>Log del Sistema

                </app-bar-item>
                <app-bar-item v-if="Admin" to="/catalogos/acceso_usuarios" @click.shift="openNew('/catalogos/acceso_usuarios');">

                    <v-icon>mdi-circle-small</v-icon>Log de Accesos

                </app-bar-item>
                <app-bar-item v-if="Admin" to="/usuarios/registro" @click.shift="openNew('/usuarios/registro');">
                    <v-icon>mdi-circle-small</v-icon>Registro de Cliente
                </app-bar-item>

            </v-list>
        </v-menu>
        <!-- Cobranza -->
        <v-menu text nav v-if="(Pagos || Admin)" bottom offset-y origin="center center" transition="scale-transition">
            <template v-slot:activator="{ attrs, on }">
                <v-btn text v-on="on">
                    <v-icon small>mdi-account-cash</v-icon>
                    <span class="caption">Cobranza</span>
                </v-btn>
            </template>
            <v-list :tile="false" nav>

                <app-bar-item to="/catalogos/pagos" @click.shift="openNew('/catalogos/pagos');">

                    <v-icon>mdi-circle-small</v-icon>Pago de Clientes

                </app-bar-item>

                <app-bar-item v-if="Admin" to="/notificaciones/enviadas" @click.shift="openNew('/notificaciones/enviadas');">

                    <v-icon>mdi-circle-small</v-icon>Notificaciones

                </app-bar-item>

                <app-bar-item v-if="Admin" to="/empresas_timer" @click.shift="openNew('/empresas_timer');">

                    <v-icon>mdi-circle-small</v-icon>Alerta de Vencimientos

                </app-bar-item>

            </v-list>
        </v-menu>

        <!-- Contenidos -->
        <v-menu text v-if="(Admin || Legal)  " bottom offset-y origin="center center" nav transition="scale-transition">
            <template v-slot:activator="{ attrs, on }">
                <v-btn text v-on="on">
                    <v-icon small>mdi-text-box-search-outline</v-icon>
                    <span class="caption">Contenidos</span>
                </v-btn>
            </template>

            <v-list :tile="false" nav>
                <v-menu v-if="Admin || Legal" open-on-hover offset-x nav transition="scale-transition">
                    <template v-slot:activator="{ attrs, on }">
                        <span v-on="on" id="menuContenidos">
                            <app-bar-item>

                                <v-icon>mdi-circle-small</v-icon>Normativo<v-icon>mdi-menu-right</v-icon>

                            </app-bar-item>
                        </span>
                    </template>

                    <v-list :tile="false" nav>

                        <app-bar-item to="/catalogos/terminos" @click.native="hideMenuReportes" @click.shift="openNew('/catalogos/terminos');">

                            <v-icon>mdi-circle-small</v-icon> Terminos y Condiciones

                        </app-bar-item>
                        <app-bar-item to="/catalogos/terminospdf" @click.native="hideMenuReportes" @click.shift="openNew('/catalogos/terminospdf');">

                            <v-icon>mdi-circle-small</v-icon> PDF Terminos y Condiciones

                        </app-bar-item>

                        <app-bar-item to="/configuracion/politicas" @click.native="hideMenuReportes" @click.shift="openNew('/configuracion/politicas');">

                            <v-icon>mdi-circle-small</v-icon> Política de Privacidad y Confidencialidad

                        </app-bar-item>

                    </v-list>
                </v-menu>

                <app-bar-item to="/catalogos/contenido" class="font-weight-thin" @click.shift="openNew('/catalogos/contenido');">
                    <v-icon>mdi-circle-small</v-icon>PDF en Módulos
                </app-bar-item>

                <app-bar-item v-if="Admin"  to="/catalogos/fondos" class="font-weight-thin" @click.shift="openNew('/catalogos/contenidofondo');">
                    <v-icon>mdi-circle-small</v-icon>Imagenes de Fondo
                </app-bar-item>

                <app-bar-item v-if="Admin" to="/catalogos/etips" @click.shift="openNew('/catalogos/etips');">
                    <v-icon>mdi-circle-small</v-icon>eTips
                </app-bar-item>

                <app-bar-item v-if="Admin" to="/catalogos/avisos" @click.shift="openNew('/catalogos/avisos');">
                    <v-icon>mdi-circle-small</v-icon>Avisos y Video Tutoriales
                </app-bar-item>

                <v-divider />
                <app-bar-item to="/catalogos/etipsHTML" @click.shift="openNew('/catalogos/etipsHTML');">
                    <v-icon>mdi-circle-small</v-icon> Manual de Usuario
                </app-bar-item>

                <app-bar-item to="/videotutorial" @click.shift="openNew('/videotutorial');">
                    <v-icon>mdi-circle-small</v-icon>Consulta Video Tutoriales
                </app-bar-item>
            </v-list>
        </v-menu>

        <!-- Catalogos admin -->
        <v-menu v-if="Admin" nav bottom offset-y origin="center center" transition="scale-transition">
            <template v-slot:activator="{ attrs, on }">
                <v-btn text v-on="on">
                    <v-icon>mdi-file-table-box-multiple-outline</v-icon>
                    <span class="caption">Catálogos</span>
                </v-btn>
            </template>
            <v-list :tile="false" nav>

                <app-bar-item to="/catalogos/erroresws" @click.shift="openNew('/catalogos/erroresws');">
                    <v-icon>mdi-circle-small</v-icon>Errores WS
                </app-bar-item>

                <app-bar-item to="/apendices/24" @click.shift="openNew('/apendices/24');">
                    <v-icon>mdi-circle-small</v-icon>Apéndices
                </app-bar-item>

                <app-bar-item to="/catalogos/aduanas" @click.shift="openNew('/catalogos/aduanas');">
                    <v-icon>mdi-circle-small</v-icon>Aduanas
                </app-bar-item>

                <app-bar-item to="/catalogos/permisos" @click.shift="openNew('/catalogos/permisos');">
                    <v-icon>mdi-circle-small</v-icon>Permisos por Dependencia
                </app-bar-item>

                <app-bar-item to="/catalogos/empresasimmex" @click.shift="openNew('/catalogos/empresasimmex');">
                    <v-icon>mdi-circle-small</v-icon>Empresas - Programas de Fomento
                </app-bar-item>

                <app-bar-item to="/catalogos/tipos_empresas" @click.shift="openNew('/catalogos/tipos_empresas');">
                    <v-icon>mdi-circle-small</v-icon>Tipos de Industria
                </app-bar-item>

                <app-bar-item to="/catalogos/tipos_servicios" @click.shift="openNew('/catalogos/tipos_servicios');">
                    <v-icon>mdi-circle-small</v-icon>Tipos de Servicios
                </app-bar-item>

                <app-bar-item to="/catalogos/urls" @click.shift="openNew('/catalogos/urls');">
                    <v-icon>mdi-circle-small</v-icon>URLs del Sistema
                </app-bar-item>

                <app-bar-item to="/catalogos/estados_ws" @click.shift="openNew('/catalogos/estados_ws');">
                    <v-icon>mdi-circle-small</v-icon>Estados de Pedimento WS
                </app-bar-item>








                <v-menu   open-on-hover offset-x nav transition="scale-transition">
     <template v-slot:activator="{ attrs, on }">
        <span v-on="on" id="menuInsumos">
                    <app-bar-item>

                        <v-icon>mdi-circle-small</v-icon>Insumos SAT<v-icon>mdi-menu-right</v-icon>

                        </app-bar-item>
                   
                </span>
            </template>

        <v-list :tile="false" nav>
            <app-bar-item  @click.native="hideMenuReportes" to="/carta_porte/catalogos_sat/productos">
                <v-icon>mdi-circle-small</v-icon>Productos y Servicios
            </app-bar-item>
            <app-bar-item  @click.native="hideMenuReportes" to="/carta_porte/catalogos_sat/materiales_peligrosos">
                <v-icon>mdi-circle-small</v-icon>Materiales Peligrosos
            </app-bar-item>
            <app-bar-item  @click.native="hideMenuReportes" to="/carta_porte/catalogos_sat/embalajes">
                <v-icon>mdi-circle-small</v-icon>Tipos de Embalajes
            </app-bar-item>
            <app-bar-item  @click.native="hideMenuReportes" to="/carta_porte/catalogos_sat/config_auto">
                <v-icon>mdi-circle-small</v-icon>Configuración Vehicular
            </app-bar-item>
            <app-bar-item  @click.native="hideMenuReportes" to="/carta_porte/catalogos_sat/ubicaciones">
                <v-icon>mdi-circle-small</v-icon>Ubicaciones
            </app-bar-item>
        </v-list>
    </v-menu>












            </v-list>
        </v-menu>

        <!-- Preguntas -->
        <v-btn text v-if="Admin" to="/catalogos/equestions" @click.shift="openNew('/catalogos/equestions');" style="text-decoration: none; left:-15px">
            <v-icon>help</v-icon>
            <span class="caption">Preguntas</span>
        </v-btn>

        <!-- Reportes -->
        <v-menu bottom offset-y origin="center center" nav transition="scale-transition" v-if="Admin">
            <template v-slot:activator="{ attrs, on }">
                <v-btn text v-on="on" :icon="fullWidth <= 1024" :title="fullWidth < 1024?'Reportes':''" v-tippy>
                    <v-icon>file_copy</v-icon>
                    <span class="caption" v-show="fullWidth > 1024">Reportes</span>
                </v-btn>
            </template>
            <v-list :tile="false" nav>

                <app-bar-item v-if="Admin" to="/reportes/rfc_agentes" @click.shift="openNew('/reportes/rfc_agentes');">
                    <v-icon>mdi-circle-small</v-icon>Consulta BD-WS Patentes Aduanales
                </app-bar-item>
                <app-bar-item v-if="Admin" to="/reportes/rfc_coves_agentes" @click.shift="openNew('/reportes/rfc_coves_agentes');">
                    <v-icon>mdi-circle-small</v-icon>Consulta BD-WS RFC AA Coves-Remesas
                </app-bar-item>
                <app-bar-item v-if="Admin" to="/reportes/rfc_identificadores" @click.shift="openNew('/reportes/rfc_identificadores');">
                    <v-icon>mdi-circle-small</v-icon>Consulta BD-WS RFC/Patente Filtros
                </app-bar-item>
                <app-bar-item v-if="Admin" to="/reportes/consulta_501" @click.shift="openNew('/reportes/consulta_501');">
                    <v-icon>mdi-circle-small</v-icon>Consulta 501 WS
                </app-bar-item>
                <app-bar-item v-if="Admin" to="/reportes/consulta_551" @click.shift="openNew('/reportes/consulta_551');">
                    <v-icon>mdi-circle-small</v-icon>Consulta 551 WS
                </app-bar-item>
                <app-bar-item v-if="Admin" to="/reportes/consulta_501_ds" @click.shift="openNew('/reportes/consulta_501_ds');">
                    <v-icon>mdi-circle-small</v-icon>Consulta 501 DS
                </app-bar-item>
                <app-bar-item v-if="Admin" to="/reportes/consulta_551_ds" @click.shift="openNew('/reportes/consulta_551_ds');">
                    <v-icon>mdi-circle-small</v-icon>Consulta 551 DS
                </app-bar-item>
                <app-bar-item v-if="Admin" to="/reportes/recuperaciones_usuario" @click.shift="openNew('/reportes/recuperaciones_usuario');">
                    <v-icon>mdi-circle-small</v-icon>Recuperaciones por Usuario
                </app-bar-item>                

            </v-list>
        </v-menu>

        <!-- Utilerías -->
        <v-menu bottom offset-y origin="center center" nav transition="scale-transition" v-if="Admin">
            <template v-slot:activator="{ attrs, on }">
                <v-btn text v-on="on" :icon="fullWidth <= 1024" :title="fullWidth < 1024?'Utilerías':''" v-tippy>
                    <v-icon>card_travel</v-icon>
                    <span class="caption" v-show="fullWidth > 1024">Utilerías</span>
                </v-btn>
            </template>
            <v-list :tile="false" nav>
                <app-bar-item v-if="Admin" to="/utilerias/lineas_captura" @click.shift="openNew('/utilerias/lineas_captura');">
                    <v-icon>mdi-circle-small</v-icon>Líneas de Captura
                </app-bar-item>
                <app-bar-item v-if="Admin" to="/reportes/rpt_contribuciones_admin" @click.shift="openNew('/reportes/rpt_contribuciones_admin');">
                    <v-icon>mdi-circle-small</v-icon>Contribuciones
                </app-bar-item>
                <app-bar-item v-if="Admin" to="/utilerias/solicitud_consulta" @click.shift="openNew('/utilerias/solicitud_consulta');">
                    <v-icon>mdi-circle-small</v-icon>Solicitud Consulta
                </app-bar-item>
            </v-list>
        </v-menu>

        <!-- Service Desk -->
        <v-menu bottom offset-y origin="center center" nav transition="scale-transition" v-if="Admin">
            <template v-slot:activator="{ attrs, on }">
                <v-btn text v-on="on" :icon="fullWidth <= 1024" :title="fullWidth < 1024?'Service Desk':''" v-tippy>
                    <v-icon>mdi-ticket-confirmation</v-icon>
                    <span class="caption" v-show="fullWidth > 1024">Service Desk</span>
                </v-btn>
            </template>
            <v-list :tile="false" nav>
                <app-bar-item v-if="Admin" to="/servicedesk/tickets" @click.shift="openNew('/servicedesk/tickets');">
                    <v-icon>mdi-circle-small</v-icon>Tickets
                </app-bar-item>
                <app-bar-item v-if="Admin" to="/servicedesk/proyectos" @click.shift="openNew('/servicedesk/proyectos');">
                    <v-icon>mdi-circle-small</v-icon>Proyectos
                </app-bar-item>                
            </v-list>
        </v-menu>
        </div>
</template>

<script>
// Components
import {
    VHover,
    VListItem
} from "vuetify/lib";

// Utilities
import {
    mapState,
    mapMutations
} from "vuex";


export default {
    name: "MenuSuperUser",
    components: {

        AppBarItem: {
            render(h) {
                return h(VHover, {
                    scopedSlots: {
                        default: ({
                            hover
                        }) => {
                            return h(
                                VListItem, {
                                    attrs: this.$attrs,
                                    class: {
                                        "black--text": !hover,
                                        "white--text secondary elevation-12": hover
                                    },
                                    props: {
                                        activeClass: "",
                                        dark: hover,
                                        link: true,
                                        ...this.$attrs
                                    }
                                },
                                this.$slots.default
                            );
                        }
                    }
                });
            }
        }
    },

    props: {
        value: {
            type: Boolean,
            default: false
        }
    },

    data: () => ({
        fab: false,

        show_loading: false,
        notificationsNumber: 0,
        show: true,
        rfc: "",
        razon: "",
        tipo_usuario: "",
        id_cliente: 0,
        minifiedLeft: false,
        hiddenLeft: false,
        avatar: "undefined",
        fullWidth: document.documentElement.clientWidth,
        notifications: [
            "Mike John Responded to your email",
            "You have 5 new tasks",
            `You're now friends with Andrew`,
            "Another Notification",
            "Another one"
        ]
    }),

    computed: {
        ...mapState(["drawer"]),


        Admin() {
            return (
                this.$local_storage.get("tipo_usuario") == "Super Usuario" &&
                this.$local_storage.get("id_cliente") == 0 && this.$local_storage.get('id_grupo') == 0
            );
        },
        Legal() {
            return (this.$local_storage.get("tipo_usuario") == "Asuntos Legales") && this.$local_storage.get('id_grupo') == 0;
        },
        Pagos() {
            return (this.$local_storage.get("tipo_usuario") == "Pagos") && this.$local_storage.get('id_grupo') == 0;
        },


    },

    methods: {
        ...mapMutations({
            setDrawer: "SET_DRAWER"
        }),


        openNew: function (h) {
            window.open(h, "_blank");
        },

        hideMenuReportes: function () {

          
            var menu6 = document.getElementById("menuInsumos");


            if (menu6) {
                menu6.click();
            }
            
            var menu1 = document.getElementById("menuContenidos");


            if (menu1) {
                menu1.click();
            }
            
        },
            
    },

};
</script>

<style scoped>
.v-menu__content .v-list--nav .v-list-item {
    padding-top: 0px;
    padding-bottom: 0px;
    padding-left: 5px;
    text-decoration: none;
}

.v-sheet button.v-btn.v-size--default:not(.v-btn--icon):not(.v-btn--fab) {
    padding-left: 10px !important;
}
</style>
